import * as targetEnv from "targetenv";


/**
 * Adds an object to the global variable's 'dbg' object for the purposes of browser debugging.
 */
export function exportInGlobalDbg<T>(name: string, debugObj: T): T {
    if (typeof name !== "string" || name.length === 0) {
        throw new Error("A name must be specified for the object");
    }

    if (targetEnv.isBrowser) {
        const expandableGlobal = (<any>global);

        if (!expandableGlobal.dbg) {
            expandableGlobal.dbg = {};
        }
        expandableGlobal.dbg[name] = debugObj;
    }

    return debugObj;
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/util/debug.ts